import { BASE_URL } from "../constants";

// const baseUrl = 'http://localhost:8080/api';
const baseUrl = BASE_URL;
// const baseUrl = 'http://208.76.222.129:8003/api';
export default baseUrl;
